import { createAsyncThunk } from '@reduxjs/toolkit';

import type { RootState } from 'features/app/store/store';
import { CallDaoService } from 'features/call/call-base/services';
import { selectActualCallOwnerUserId } from 'features/call/call-base/store/selectors';
import type { PreviousCall } from 'features/call/previous-calls/interfaces';

interface PreviousCallApiResponse {
  callId: number;
  startDt: string;
  endDt: string;
  lastState: string;
  callTypeStart: string;
  callTypeEnd: string;
  callerConnectionString: string;
  terminationReasonCode: string;
}

export const fetchPreviousCalls = createAsyncThunk(
  'previousCalls/fetchPreviousCalls',
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const userId = selectActualCallOwnerUserId(state);

      if (!userId) {
        return rejectWithValue('User ID not found');
      }

      const response =
        await CallDaoService.getLastFiveCallsByInterpreterId(userId);

      const transformedCalls: PreviousCall[] = Array.isArray(response)
        ? (response as PreviousCallApiResponse[])
            .filter((call) => call.callId)
            .map((call) => ({
              callId: call.callId,
              startTime: call.startDt,
              endTime: call.endDt,
              lastState: call.lastState,
              callTypeStart: call.callTypeStart,
              callTypeEnd: call.callTypeEnd,
              callerConnectionString: call.callerConnectionString,
              terminationReasonCode: call.terminationReasonCode,
            }))
        : [];

      return transformedCalls;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
